// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1YsJK","disabled":"FileBtn_disabled__3DZjQ","warn":"FileBtn_warn__3Sxqj","fade":"FileBtn_fade__ZcXNI"};